// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Loadable, Loaded } from '@app/core';
import { PolicyDetail, LoadingStatus } from '../../../core/models/index';
import { PolicyDetailsActions, PolicyDetailsActionTypes } from './policy-details.actions';

export interface PolicyDetailsState {
  [policyId: string]: {
    details: Loadable | Loaded<PolicyDetail>;
  };
}

export function policyDetailsReducer(state: PolicyDetailsState = {}, action: PolicyDetailsActions) {
  switch (action.type) {
    case PolicyDetailsActionTypes.SELECT_POLICY:
      return {
        ...state,
        [action.payload.id]: {
          details: {
            ...getDetails(state, action.payload),
            data: {
              ...getData(state, action.payload),
              policy: action.payload
            }
          }
        }
      };
    case PolicyDetailsActionTypes.POLICY_DETAILS_LOAD_COMPLETE:
      return {
            ...state,
            [action.payload.policy_id]: {
              details: {
                status: LoadingStatus.LOAD_COMPLETE,
                data: {
                  policy: action.payload,
                },
              }
            }
          };

    case PolicyDetailsActionTypes.POLICY_DETAILS_LOAD_FAILED:
      return {
        ...state,
        [action.payload]: {
          details: {
            ...getDetails(state, action.payload),
            status: LoadingStatus.LOAD_FAILED
          }
        }
      };
    default:
      return state;
  }
}

function getDetails(state: any, payload: any) {
  if (!state) {
    return {};
  }

  if (!state[payload.id]) {
    return {};
  }

  return state[payload.id].details || {};
}

function getData(state: any, payload: any) {
  return getDetails(state, payload).data || {};
}


export function getPolicyDetailsLoadable(id: string): (state: PolicyDetailsState) => Loadable | undefined {
    return (state) => {
      if (!state[id]) {
        return undefined;
      }
      const loadableDetails = <Loadable>state[id].details;
      if (!loadableDetails.status) {
        return undefined;
      }
      return loadableDetails;
    };
}

export function getPolicyDetails(id: string): (state: PolicyDetailsState) => PolicyDetail | undefined {
    return (state) => {
      if (!state[id]) {
        return undefined;
      }
      return state[id].details.data;
    };
  }



// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-details/policy-details.reducer.ts